module.exports = __webpack_public_path__ + "static/img2-9e47dfe36852552104c5b286252c98bb.jpg";